import { render } from "./PencilSVG.vue?vue&type=template&id=3b9c6cd8"
import script from "./PencilSVG.vue?vue&type=script&lang=js"
export * from "./PencilSVG.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__